import {Injectable} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {RequestService} from '../services/request.service';
import {TranslateService} from '@ngx-translate/core';


@Injectable()
export class ErrorHandler {

  constructor(
    public snackbar: MatSnackBar,
    private router: Router,
    private _request: RequestService,
    private _location: Location,
    private translate: TranslateService
  ) {
  }

  public handleError(err: any) {
    let msg = '';
    try {
      console.error('HTTP Error', err);

      if (err.error.hasOwnProperty('message')) {
        msg = err.error.message;
      } else {
        msg = this.translate.instant('HOME.txt.unexpected_error');
      }
      console.error('message to display', msg, err.status);

      if (err.status === 401 && msg === 'Vous vous etes connecté à un autre compte') {
        localStorage.setItem('userInfo', '');
        localStorage.setItem('_token', '');
        const txt = this.translate.instant('HOME.txt.reconnect_msg');
        const title = this.translate.instant('HOME.txt.disconnection_msg');

        this._request.notifySuccess('error', title, txt);
        setTimeout(() => {
          this.snackbar.open(msg, 'OK', {
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 7000
          });
        });
        this.router.navigate(['/']);
        return;
      }

      // status: 401


      if (msg === 'Token has expired') {
        localStorage.setItem('userInfo', '');
        localStorage.setItem('_token', '');
        this._request.notifySuccess('error', 'Deconnexion', 'Votre session a expiré');
        this.router.navigate(['/']);
      } else if (msg === 'Token not provided') {
        localStorage.setItem('userInfo', '');
        localStorage.setItem('_token', '');
        this._request.notifySuccess('error', 'Deconnexion', 'Votre session est invalide');
        this.router.navigate(['/']);
      } else if (msg === 'The token has been blacklisted') {
        localStorage.setItem('userInfo', '');
        localStorage.setItem('_token', '');
        this._request.notifySuccess('error', 'Deconnexion', 'Votre session va se fermer');
        this.router.navigate(['/login']);
      } else if (msg.toLowerCase().indexOf('Authorization') >= 0
        || msg.toLowerCase().indexOf('credential') >= 0) {
        this.router.navigate(['/']);
        setTimeout(() => {
          this.snackbar.open(msg, 'OK', {
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 7000
          });
        });
      } else {
        setTimeout(() => {
          this.snackbar.open(msg, 'OK', {
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 7000
          });
        });
      }

    } catch (e) {
      console.error('error exception', e);
      setTimeout(() => {
        this.snackbar.open('Error Server. Contact Admin', 'OK',
          {
            verticalPosition: 'top',
            horizontalPosition: 'center', panelClass: ['grey-snackbar'],
            duration: 7000
          });
      });
    }

  }
}
